import styled from "styled-components";
import { colors } from "@/theme";

export const Container = styled.div`
  padding: 10px;
  border: 1px solid ${colors.black};
  border-radius: 12px;
`;

export const Header = styled.div`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: bold;
  line-height: 16px;
  margin-bottom: 10px;
  text-align: center;
`;

export const ExportOrdersContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  justify-items: center;
  align-items: center;
`;

export const ExportRadioGroupContainer = styled.div`
  padding: 10px;
  border: 1px solid ${colors.black};
  border-radius: 12px;
`;
